import { useEffect, useState } from "react";

function SelectSearch({
  value,
  name,
  label,
  onChange,
  options,
  searchText,
  error,
  placeholder,
  onBluer,
  onFocus,
  onSearch,
  onSelect,
}) {
  const [isOpen, setIsOpen] = useState(false);
  const [search, setSearch] = useState("");
  const [selected, setSelected] = useState(value);

  const handleChange = (e) => {
    setSearch(e.target.value);
    if (onSearch) {
      onSearch(e.target.value);
    }

    if (e.target.value === "") {
      setSelected("");
    }
  };

  const handleSelect = (option) => {
    setSelected(option.value);
    setSearch(option.label);
    setIsOpen(false);
    if (onSelect) {
      onSelect({ name, value: option.value });
    }
  };

  const handleFocus = (e) => {
    setIsOpen(true);
  };

  const handleBlur = (e) => {
    setTimeout(() => {
      setIsOpen(false);
    }, 300);
  };

  // useEffect(() => {
  //   console.log("searchText", searchText);
  //   if (searchText) {
  //     setSearch(searchText);
  //   }
  // }, [searchText]);

  useEffect(() => {
    if (value && search === "" && !isOpen) {
      setSelected(value);
      setSearch(options?.find((option) => option.value === value)?.label || "");
    }
  }, [value, options]);

  const handleOptions = (option) => {
    return (
      option.label?.toLowerCase().includes(search?.toLowerCase()) ||
      option.searchable?.toLowerCase().includes(search?.toLowerCase())
    );
  };

  return (
    <div style={{ position: "relative" }}>
      {label && <label>{label}</label>}
      <input
        name={name}
        type="text"
        className={`form-control ${error ? "is-invalid" : ""}`}
        placeholder={placeholder}
        onFocus={handleFocus}
        onBlur={handleBlur}
        value={search}
        onChange={handleChange}
        autoComplete="off"
      />
      <div>
        {isOpen && (
          <div
            style={{
              marginTop: "0.75rem",
              position: "absolute",
              top: "100%",
              left: 0,
              zIndex: 10,
              backgroundColor: "white",
              width: "100%",
              borderRadius: "0.5rem",
              boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
              maxHeight: "13rem",
              overflowY: "auto",
              padding: "0.5rem",
            }}
          >
            <ul
              tabIndex={-1}
              style={{
                margin: 0,
                padding: "0.25rem 0",
                listStyle: "none",
                maxHeight: "12rem",
                overflowY: "auto",
                scrollbarWidth: "thin",
              }}
            >
              {options.filter(handleOptions).map((option) => (
                <li
                  key={option.value}
                  onClick={() => handleSelect(option)}
                  style={{
                    padding: "0.5rem",
                    cursor: "pointer",
                    borderRadius: "0.25rem",
                    transition: "background-color 0.2s ease-in-out",
                    backgroundColor:
                      selected === option.value ? "#f0f0f0" : "transparent",
                  }}
                  onMouseEnter={(e) =>
                    (e.currentTarget.style.backgroundColor = "#e0e0e0")
                  }
                  onMouseLeave={(e) =>
                    (e.currentTarget.style.backgroundColor =
                      selected === option.value ? "#f0f0f0" : "transparent")
                  }
                >
                  {option.label}
                </li>
              ))}
            </ul>
          </div>
        )}
      </div>
      {error && (
        <span style={{ color: "red", fontSize: "0.875rem" }}>{error}</span>
      )}
    </div>
  );
}

export default SelectSearch;
